module.exports = "https://trybtryb-legacy.web.app/img/creator-school.07fe95c4.webp";